import React from 'react';

import { ColorTokenProp } from '../../../theme/tokens/color';
import { FontWeightProp } from '../../../theme/tokens/font-weight';

import { InlineAnchor } from '../styles';

import { NodeProps } from './shared';

interface EmbeddedInlineEntryNodeProps extends NodeProps {
  colour: ColorTokenProp;
  fontWeight?: FontWeightProp;
}
export function EmbeddedInlineEntryNode({
  node,
  colour,
  fontWeight = 'inlineAnchor'
}: EmbeddedInlineEntryNodeProps) {
  const {
    fields: { url, title, openInNewTab },
    sys
  } = node.data?.target ?? {};

  if (sys?.contentType?.sys?.id === 'link') {
    return (
      <InlineAnchor
        href={url}
        target={openInNewTab && '_blank'}
        colour={colour}
        fontWeight={fontWeight}
      >
        {title}
      </InlineAnchor>
    );
  } else {
    return null;
  }
}
